// extracted by mini-css-extract-plugin
export default {"root":"xgFVKlFRb7yQR82iueMo","skeleton":"w02JeOpMK9oNje6P2g2g","placeholderCard":"Af7pMYDoqDvhgsA1pQRQ","active":"M4LRBNvA3veB7xmd5cXF","hidden":"vialBSpOEIhT1tOiAkre"};